/*
 * @Author: gaozitian
 * @Date:   2021-08-25 12:47:38
 */
import { service } from '@/utils/request'

/**
 * 静态url
 * [baseUrl 公共域名]
 * @type {[obj]}
 */
export default {

  search(data) {
    return service({
      url: '/cloud/camp/admin/group/search',
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/selectCamp/index.js